/**
 * El estado del aviso. Los dos valores reales llevan su color; cualquier otro
 * se pinta en gris con su propio texto en lugar de desaparecer.
 *
 * Es la contrapartida en pantalla de que el backend publique `estado` como
 * texto y no como union cerrada: si el proceso que rellena `avisos_estado`
 * anadiese un tercer estado, esa fila se sigue leyendo.
 */
// Tonos frios a proposito. El ambar y el rojo quedan reservados para las
// semanas sin pedir, que es la senal que justifica la seccion: un "Pendiente"
// en ambar competiria en la misma fila con el "Atencion" de la columna de al
// lado y las dos marcas se anularian.
const ESTILOS: Record<string, string> = {
  pendiente: 'bg-pendiente-fondo text-pendiente-tinta ring-pendiente-anillo',
  avisado: 'bg-avisado-fondo text-avisado-tinta ring-avisado-anillo',
}

const NEUTRO = 'bg-pendiente-fondo text-pendiente-tinta ring-pendiente-anillo'

function capitalizar(texto: string): string {
  return texto.charAt(0).toUpperCase() + texto.slice(1)
}

export function InsigniaEstado({ estado }: { estado: string }) {
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ${
        ESTILOS[estado] ?? NEUTRO
      }`}
    >
      {capitalizar(estado)}
    </span>
  )
}
